"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFromYouwellApi = void 0;
var connected_react_router_1 = require("connected-react-router");
var apiUrls_1 = __importDefault(require("../apiUrls"));
var fetchUtils_1 = require("../fetchUtils");
var RequestStatusStore_1 = require("./RequestStatusStore");
function handleOptions(dispatch, data, options) {
    if (!options) {
        return;
    }
    if (options.callback) {
        options.callback(data);
    }
    if (options.redirectWithElementId) {
        dispatch((0, connected_react_router_1.push)("".concat(options.redirectWithElementId, "/").concat(data === null || data === void 0 ? void 0 : data.id)));
    }
    else if (options.redirect) {
        dispatch((0, connected_react_router_1.push)(options.redirect));
    }
    else if (options.redirectExternal) {
        window.location.href = options.redirectExternal;
    }
}
function handleErrorOptions(dispatch, options) {
    if (!options) {
        return;
    }
    if (options.errorCallback) {
        options.errorCallback();
    }
    if (options.redirectOnError) {
        dispatch((0, connected_react_router_1.push)(options.redirectOnError));
    }
}
var startRequest = function (dispatch, requestId, background) {
    if (background === void 0) { background = false; }
    dispatch((0, RequestStatusStore_1.setRequestStatus)({
        requestId: requestId,
        background: background,
        loading: true,
        completed: false,
    }));
};
var completeRequest = function (dispatch, requestId, background) {
    if (background === void 0) { background = false; }
    dispatch((0, RequestStatusStore_1.setRequestStatus)({
        requestId: requestId,
        background: background,
        loading: false,
        completed: true,
    }));
};
var failRequest = function (dispatch, requestId, error, background) {
    if (background === void 0) { background = false; }
    dispatch((0, RequestStatusStore_1.setRequestStatus)({
        requestId: requestId,
        background: background,
        loading: false,
        completed: false,
        error: error,
    }));
};
// eslint-disable-next-line import/prefer-default-export
function fetchFromYouwellApi(dispatch, requestOptions, options) {
    var method = requestOptions.method || 'GET';
    var baseUrl = (options === null || options === void 0 ? void 0 : options.baseUrl) || apiUrls_1.default.baseUrl;
    var requestId = "".concat((options === null || options === void 0 ? void 0 : options.background) ? 'b_' : '').concat(method, ":").concat(requestOptions.apiPath);
    startRequest(dispatch, requestId, options === null || options === void 0 ? void 0 : options.background);
    (0, fetchUtils_1.youwellFetch)("".concat(baseUrl, "/").concat(requestOptions.apiPath).concat((0, fetchUtils_1.mapToQueryString)(requestOptions.queryParams)), {
        headers: __assign({}, fetchUtils_1.jsonHeader),
        method: method,
        body: requestOptions.body ? JSON.stringify(requestOptions.body) : undefined,
    })
        .then((0, fetchUtils_1.handleErrors)(dispatch))
        .then(fetchUtils_1.json)
        .then(function (data) {
        completeRequest(dispatch, requestId, options === null || options === void 0 ? void 0 : options.background);
        dispatch(requestOptions.dataAction({ response: data || null, requestBody: requestOptions.body || null, requestQuery: requestOptions.queryParams || null }));
        handleOptions(dispatch, data, options);
    })
        .catch(function (error) {
        failRequest(dispatch, requestId, error, options === null || options === void 0 ? void 0 : options.background);
        handleErrorOptions(dispatch, options);
    });
}
exports.fetchFromYouwellApi = fetchFromYouwellApi;
